import type { BinaryReader } from '../../../common/BinaryReader';
import { AbstractSerializer } from '../../../common/AbstractSerializer';
import type { LayerRecord } from '@visualizer/types';

export default class InfoSerializer extends AbstractSerializer<void> {
    public readonly version = 6;

    public async read(reader: BinaryReader, layer: LayerRecord): Promise<void> {
        void reader;
        void layer;
    }
}
